export enum UnitsConversionEnum {
  TEMPERATURE = 'Temperature',
  PRESSURE = 'Pressure',
  FREQUENCY = 'Frequency',
  POWER = 'Power',
  CURRENT = 'Current',
  DISTANCE = 'Distance',
  ENERGY = 'Energy',
  FLOW = 'Flow',
  FORCE = 'Force',
  MASS = 'Mass',
  TIME = 'Time',
  VIBRATION_ACCELERATION = 'Vibration acceleration',
  VOLTAGE = 'Voltage',
  VOLUME = 'Volume',
  VIBRATION_DISPLACEMENT = 'Vibration displacement',
  VIBRATION_VELOCITY = 'Vibration velocity',
  SPECIFIC_POWER = 'Specific power',
  AREA = 'Area',
  LOUDNESS = 'Loudness',
  MAGNETIC = 'Magnetic',
  RADIATION = 'Radiation',
  RATIO = 'Ratio',
  SCALAR = 'Scalar',
  TORQUE = 'Torque',
  VISCOSITY = 'Viscosity',
}
